import { useTranslation } from "react-i18next"
import { TabsItem } from "../enums"
import { ListTabItem } from "../../../../../../components/customeTab/types"
import { getUserRole } from "../../../../../../service/auth"
import { Roles } from "../../../../../../utils/enums"

export const useListTabDefault = (): ListTabItem[] => {
    const { t } = useTranslation()
    const role = getUserRole()
    const tabsAdmin: ListTabItem[] = [
        {
            id: TabsItem.ACTIVITY_REGISTER,
            label: t('loogbook.tabs.activityRegister'),
            value: TabsItem.ACTIVITY_REGISTER
        },
        {
            id: TabsItem.MY_ACTIVITY,
            label: t('loogbook.tabs.myActivity'),
            value: TabsItem.MY_ACTIVITY
        },
        {
            id: TabsItem.DAILYCUTS,
            label: t('loogbook.tabs.dailyCuts'),
            value: TabsItem.DAILYCUTS
        },
        {
            id: TabsItem.ACCESS,
            label: t('loogbook.tabs.access'),
            value: TabsItem.ACCESS
        },
        {
            id: TabsItem.CATALOG,
            label: t('loogbook.tabs.catalog'),
            value: TabsItem.CATALOG
        },
    ]

    const tabsOtherRoles: ListTabItem[] = [
        {
            id: TabsItem.ACTIVITY_REGISTER,
            label: t('loogbook.tabs.activityRegister'),
            value: TabsItem.ACTIVITY_REGISTER
        },
        {
            id: TabsItem.MY_ACTIVITY,
            label: t('loogbook.tabs.myActivity'),
            value: TabsItem.MY_ACTIVITY
        },
        {
            id: TabsItem.DAILYCUTS,
            label: t('loogbook.tabs.dailyCuts'),
            value: TabsItem.DAILYCUTS
        },
    ]

    const tabsParnertRole: ListTabItem[] = [
        {
            id: TabsItem.MY_ACTIVITY,
            label: t('loogbook.tabs.myActivity'),
            value: TabsItem.MY_ACTIVITY
        },
        {
            id: TabsItem.DAILYCUTS,
            label: t('loogbook.tabs.dailyCuts'),
            value: TabsItem.DAILYCUTS
        },
    ]

    switch (role) {
        case Roles.ADMIN:
            return tabsAdmin;
        case Roles.PARTNER:
            return tabsParnertRole;
        default:
            return tabsOtherRoles;
    }
}